import { useAnalyticsModalContext } from "PFApp/analytics/parts/top_actions_panel/analytics_modal_context_provider";
import {
  getCategoryTitle,
  getFieldsSortOrder
} from "PFApp/analytics/parts/top_actions_panel/export_wizard_content/export_fields_utils";
import { ExportCategories, ExportField } from "PFApp/analytics/types/export_analytics";
import React, { JSX, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

import css from "./fields_viewer.module.scss";

interface FieldsViewerProps {
  items: ExportCategories;
}

export const FieldsViewer = ({ items }: FieldsViewerProps): JSX.Element => {
  const {
    state: {
      data: { selectedFields }
    }
  } = useAnalyticsModalContext();
  const { t } = useTranslation("insights", { keyPrefix: "exportWizard.fields" });

  const sortOrder = useMemo(() => getFieldsSortOrder(items), [items]);

  const sortByFieldsOrder = useCallback(
    ({ id: id1 = "" }: ExportField, { id: id2 = "" }: ExportField) =>
      sortOrder.indexOf(id1) - sortOrder.indexOf(id2),
    [sortOrder]
  );

  const sortedFields = useMemo(
    () => selectedFields.sort(sortByFieldsOrder),
    [selectedFields, sortByFieldsOrder]
  );

  return (
    <>
      <p className={css.fieldsSelected}>{t("fieldsSelected", { count: selectedFields.length })}</p>
      {!!sortedFields.length && (
        <div className={css.tableContainer}>
          <table className={css.table}>
            <tbody>
              <tr>
                {sortedFields.map((field) => (
                  <td key={field.id} className={css.cell}>
                    <p className={css.label}>{getCategoryTitle(field.id)}</p>
                    <p className={css.label}>{field.title}</p>
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};
